'use client';
import React, { useEffect, useRef } from 'react';
import { ModalStatusEnum, useModalStatus, useModalStoreActions } from '@/store';

interface GlassModalProps {
	children: React.ReactNode;
	onClose: () => void;
}

const WalletCurrencyWrapper = ({ children, onClose }: GlassModalProps) => {
	const modalRef = useRef<HTMLDivElement>(null);
	const { setModalStatus } = useModalStoreActions();
	const modalStatus = useModalStatus();

	// useEffect(() => {
	// 	if (modalStatus === ModalStatusEnum.WalletCurrencyDropdown) return;
	// 	document.body.style.overflow = 'hidden';
	// 	return () => {
	// 		document.body.style.overflow = 'unset';
	// 	};
	// }, [modalStatus]);

	useEffect(() => {
		if (modalStatus == null) return;
		const handleClickOutside = (event: MouseEvent) => {
			if (
				event.target instanceof Element &&
				event.target.id === 'glass-modal'
			) {
				onClose();
				setModalStatus(null);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [onClose, setModalStatus, modalStatus]);

	return (
		<div
			id="glass-modal"
			className={`fixed z-[5000] h-screen w-screen overflow-x-hidden overflow-y-scroll`}
			ref={modalRef}
		>
			{children}
		</div>
	);
};

export default WalletCurrencyWrapper;
